import styled from 'styled-components';

export const ResumeItem = styled.div`
    margin-bottom: 2.5rem;
}`;

export const ResumeTitle = styled.p`
    margin: 0;

    span:nth-of-type(1) {
        color: white;
        font-weight: 600;
    }
`;